<template>
  <div class="payment-channel-subpage wrapper" v-loading="showLoading">
    <common-header icon-class="editor" url="paymentChannel" />

    <table class="table center">
      <tr>
        <th colspan="10">支付通道基础信息</th>
      </tr>
      <tr>
        <td>通道号</td>
        <td>
          <el-input v-model="postData.id" placeholder="后台自动生成" readonly />
        </td>
        <td>通道全称</td>
        <td>
          <el-input
            maxLength="50"
            v-model="postData.passagewayName"
            placeholder="请输入"
          />
        </td>
        <td>通道简称</td>
        <td>
          <el-input
            maxLength="20"
            v-model="postData.passagewayAbbreviation"
            placeholder="请输入"
          />
        </td>
        <!--   @input="onInputAbbreviation" -->
        <td>产品名称</td>
        <td>
          <el-input
            v-model="postData.productName"
            maxLength="50"
            placeholder="请输入"
          />
        </td>
        <td>报文头</td>
        <td>
          <el-input
            v-model="postData.messageHeader"
            maxLength="300"
            placeholder="请输入"
          />
        </td>
      </tr>
      <tr>
        <td>通讯方式</td>
        <td>
          <common-select
            v-model="postData.communicationSt"
            :list="communicationSt"
          />
        </td>
        <td>通道类型</td>
        <td>
          <common-select v-model="postData.channelType" :list="channelType" />
        </td>
        <td>通道来源</td>
        <td>
          <common-select
            v-model="postData.sourceChannelType"
            :list="sourceChannelType"
          />
        </td>
        <td>建档时间</td>
        <td colspan="2">
          <date-picker v-model="postData.createTime" time />
        </td>
      </tr>
      <tr>
        <th colspan="10">
          收单业务信息
          <el-checkbox class="add" v-model="postData.incomeStart"
            >启用</el-checkbox
          >
        </th>
      </tr>
      <tr>
        <td :class="postData.incomeStart ? '' : 'gray'">收单形式</td>
        <td>
          <common-select
            v-model="postData.incomeSt"
            :list="incomeSt"
            :disabled="!postData.incomeStart"
          />
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">保理挂接</td>
        <td>
          <common-select
            v-model="postData.factoringSt"
            :list="yesOrNo"
            :disabled="!postData.incomeStart"
          />
        </td>

        <td :class="postData.incomeStart ? '' : 'gray'">手续费减免</td>
        <td>
          <common-select
            v-model="postData.procedureCost"
            :list="procedureCost"
            :disabled="!postData.incomeStart"
          />
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">提供机具</td>
        <td>
          <common-select
            v-model="postData.machinery"
            :list="yesOrNo"
            :disabled="!postData.incomeStart"
          />
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">转换商户号</td>
        <td>
          <common-select
            v-model="postData.conversionMerchant"
            :list="yesOrNo"
            :disabled="!postData.incomeStart"
          />
        </td>
      </tr>
      <tr>
        <td :class="postData.incomeStart ? '' : 'gray'">结算方式</td>
        <td>
          <common-select
            v-model="postData.settleSt"
            :list="settleSt"
            :disabled="!postData.incomeStart"
          />
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">结算成本</td>
        <td>
          <el-input
            v-model.number="postData.settleCost"
            maxLength="5"
            placeholder="请输入"
            :disabled="!postData.incomeStart"
          />
          <span :class="postData.incomeStart ? 'editWord' : 'gray'">%</span>
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">日切时间</td>
        <td>
          <time-picker
            v-model="postData.cutTime"
            value-format="HH:mm:ss"
            :disabled="!postData.incomeStart"
          />
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">单笔最小交易</td>
        <td>
          <el-input
            v-model.number="postData.minAmt"
            maxLength="5"
            placeholder="请输入"
            :disabled="!postData.incomeStart"
          />
          <span :class="postData.incomeStart ? 'editWord' : 'gray'">元</span>
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">单笔最大交易</td>
        <td>
          <el-input
            v-model.number="postData.maxAmt"
            maxLength="5"
            placeholder="请输入"
            :disabled="!postData.incomeStart"
          />
          <span :class="postData.incomeStart ? 'editWord' : 'gray'">元</span>
        </td>
      </tr>
      <tr>
        <td :class="postData.incomeStart ? '' : 'gray'">交易起始时间</td>
        <td>
          <time-picker
            v-model="postData.startTime"
            value-format="HH:mm:ss"
            :disabled="!postData.incomeStart"
          />
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">交易终止时间</td>
        <td>
          <time-picker
            v-model="postData.endTime"
            value-format="HH:mm:ss"
            :disabled="!postData.incomeStart"
          />
        </td>
      </tr>

      <tr>
        <th colspan="10" class="left">成本录入</th>
      </tr>
      <tr v-for="(item, index) of payChannelPaymentsList" :key="index">
        <td colspan="2" :class="postData.incomeStart ? '' : 'gray'">
          {{ item.paymentType | filCostEntry }}
        </td>
        <td colspan="2">
          <el-input
            v-model="item.typeCode"
            placeholder="通道简称字母 + 标识"
            @input="onInputTypeCode(index, $event)"
            :disabled="!postData.incomeStart"
          />
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">通道费率</td>
        <td>
          <el-input
            maxLength="5"
            v-model="item.rate"
            :disabled="!postData.incomeStart"
          />
          <span class="editWord">%</span>
        </td>
        <td :class="postData.incomeStart ? '' : 'gray'">启用标识</td>
        <td colspan="4">
          <el-radio-group
            v-model="item.status"
            :class="postData.incomeStart ? '' : 'gray'"
          >
            <el-radio :disabled="!postData.incomeStart" :label="1"
              >启用</el-radio
            >
            <el-radio :disabled="!postData.incomeStart" :label="2"
              >停用</el-radio
            >
          </el-radio-group>
        </td>
      </tr>

      <tr>
        <th colspan="10">贷记业务信息</th>
      </tr>
      <tr>
        <th colspan="10" class="left">
          代付业务
          <el-checkbox class="add" v-model="postData.repayStart"
            >启用</el-checkbox
          >
        </th>
      </tr>
      <!-- <tr>
        <td>
          代付成本
        </td>
        <td>
          <el-input
            :maxlength="6"
            v-model="postData.repayCost"
            :disabled="!postData.repayStart"
          />
          <span class="editWord">元/笔</span>
        </td>
        <td>关联渠道</td>
        <td colspan="7">
          <el-input :maxlength="6" v-model="repayCostBankList" disabled />
        </td>
      </tr> -->
      <tr v-if="postData.channelType == 2">
        <td :class="postData.repayStart ? '' : 'gray'">代付成本</td>
        <td>
          <el-input
            :maxlength="6"
            v-model.number="postData.repayCost"
            :disabled="!postData.repayStart"
          />
          <span class="editWord">元/笔</span>
        </td>
        <td :class="postData.repayStart ? '' : 'gray'">关联渠道</td>
        <td colspan="7">
          <el-input :maxlength="6" v-model="postData.repayBankList" disabled />
        </td>
      </tr>
      <tr v-else-if="postData.channelType == 1">
        <td :class="postData.repayStart ? '' : 'gray'">本行代付成本</td>
        <td>
          <el-input
            :maxlength="6"
            v-model="postData.repayCostThisBank"
            :disabled="!postData.repayStart"
          />
          <span class="editWord">元/笔</span>
        </td>
        <td :class="postData.repayStart ? '' : 'gray'">跨行代付成本</td>
        <td>
          <el-input
            :maxlength="6"
            v-model="postData.repayCostOtherBank"
            :disabled="!postData.repayStart"
          />
          <span class="editWord">元/笔</span>
        </td>
        <td :class="postData.repayStart ? '' : 'gray'">关联渠道</td>
        <td colspan="5">
          <el-input :maxlength="6" v-model="postData.repayBankList" disabled />
        </td>
      </tr>
      <tr>
        <th colspan="10" class="left">
          代扣业务
          <el-checkbox class="add" v-model="postData.deductStart"
            >启用</el-checkbox
          >
        </th>
      </tr>
      <tr>
        <td :class="postData.deductStart ? '' : 'gray'">代扣能力</td>
        <td colspan="9" class="center">
          <template>
            <el-table :data="tableData" class="table-content" border>
              <el-table-column type="index" width="80" label="序号">
              </el-table-column>
              <el-table-column prop="bankName" label="银行渠道">
                <template slot-scope="scope">
                  <el-autocomplete
                    class="inline-input"
                    v-model="scope.row.bankName"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入内容"
                    :trigger-on-focus="false"
                    :disabled="!postData.deductStart"
                    @select="handleSelect"
                    @input="setIndex(scope.$index)"
                  ></el-autocomplete>
                </template>
              </el-table-column>
              <el-table-column prop="sign" label="银行标设">
                <template slot-scope="scope">
                  <el-input
                    disabled
                    v-model="scope.row.sign"
                    placeholder="请输入内容"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="repayRate" label="代扣成本(费率)">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.repayRate"
                    placeholder="请输入内容"
                    onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                    maxLength="10"
                    :disabled="!postData.deductStart"
                  ></el-input>
                  <span class="editWord span-center">%</span>
                </template>
              </el-table-column>
              <el-table-column prop="repayLowest" label="代扣成本(保底)">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.repayLowest"
                    placeholder="请输入内容"
                    onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                    maxLength="10"
                    :disabled="!postData.deductStart"
                  ></el-input>
                  <span class="editWord span-center">元/笔</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    v-if="tableData.length > 1"
                    type="text"
                    size="small"
                    :disabled="!postData.deductStart"
                    @click="del(scope.$index)"
                  >
                    <img style="width:16px" src="@/assets/del.png" alt="删除"
                  /></el-button>
                  <el-button
                    type="text"
                    size="small"
                    @click="add"
                    :disabled="!postData.deductStart"
                  >
                    <img style="width:16px" src="@/assets/add.png" alt="新增" />
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </td>
      </tr>
      <tr>
        <td>关联渠道</td>
        <td colspan="9">
          <el-input v-model="deductCostBankList" readonly />
        </td>
      </tr>
      <tr>
        <th colspan="10">结算信息</th>
      </tr>
      <tr>
        <td>财务对接人</td>
        <td>
          <el-input maxLength="20" v-model="postData.financeUserName" />
        </td>
        <td>联系电话</td>
        <td>
          <el-input maxLength="11" v-model="postData.financeUserPhone" />
        </td>
        <td>技术对接人</td>
        <td>
          <el-input maxLength="20" v-model="postData.techUserName" />
        </td>
        <td>联系电话</td>
        <td>
          <el-input maxLength="11" v-model="postData.techUserPhone" />
        </td>
        <td>结算账户</td>
        <td>
          <el-input maxLength="50" v-model="postData.settleName" />
        </td>
      </tr>
      <tr>
        <td>账号</td>
        <td>
          <el-input maxLength="50" v-model="postData.settleCardNo" />
        </td>
        <td>开户行</td>
        <td>
          <el-input maxLength="50" v-model="postData.settleOpenBank" />
        </td>
      </tr>
    </table>

    <div class="action-buttons">
      <button class="action-button clickable blue" @click="confirmEditor">
        确认修改
      </button>
    </div>
  </div>
</template>

<script>
import { autocomplete } from 'element-ui'
export default {
  props: ['id'],
  components: {
    'el-autocomplete': autocomplete
  },
  data() {
    return {
      // 通讯方式
      communicationSt: [
        { value: 1, label: 'VPN' },
        { value: 2, label: '普通' }
      ],
      // 通道类型
      channelType: [
        { value: 1, label: '银行' },
        { value: 2, label: '第三方支付公司' }
      ],
      // 渠道来源
      sourceChannelType: [
        { value: 1, label: '渠道自有第三方通道' },
        { value: 2, label: '盈众自有通道' }
      ],
      // 收款形式
      incomeSt: [
        { value: 1, label: '非固定码' },
        { value: 2, label: '固定码' }
      ],
      // 手续费减免
      procedureCost: [
        { value: 1, label: '保理交易前置' },
        { value: 2, label: '无' }
      ],
      // 结算方式
      settleSt: [
        { value: 1, label: 'T1' },
        { value: 0, label: 'T0' }
      ],
      // 是否:  保理挂接
      yesOrNo: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ],
      // 计费方式
      billingMode: [
        { value: 1, label: '费率' },
        { value: 2, label: '笔算' }
      ],
      restaurants: [],
      index: '',
      showLoading: true,
      postData: {
        // 支付通道基本信息
        id: '', // 通道号
        passagewayName: '', // 通道名称
        passagewayAbbreviation: '', // 通道简称
        productName: '', // 产品名称
        messageHeader: '', // 报文头
        communicationSt: '', //通讯方式 1: VPN 2：普通
        channelType: '', // 通道类型 1：银行 2：第三方支付公司
        sourceChannelType: '', // 通道来源 1：渠道自有第三方通道 2：盈众自有通道
        createTime: '', // 建档时间

        // 收单业务信息
        incomeStart: true, //收单业务信息 是否启用incomeStart
        incomeSt: '', // 收单形式(收款形式) 1: 非固定码 2: 固定吗
        factoringSt: '', //保理挂接 1: 是 2: 否
        procedureCost: '', // 手续费减免 1: 保理交易前置 2: 无
        machinery: '', // 提供机具 1: 是 2: 否
        conversionMerchant: '', // 转换商户号 1:是 2:否
        settleSt: '', // 结算方式 0: T0 1: T1
        settleCost: '', // 结算成本 %
        cutTime: '', //日切事件 时分秒
        minAmt: '', // 单笔最小交易金额
        maxAmt: '', // 单笔最大交易金额
        startTime: '', // 交易起始时间 时分秒
        endTime: '', // 交易终止时间 时分秒

        // 成本录入列表
        payChannelPaymentsList: [],

        // 贷记业务信息
        // 1.代付业务
        repayStart: true, // 代付业务是否启用
        // 通道类型选择第三方
        repayCost: '', //代付成本 %
        // 通道类型选择银行
        repayCostThisBank: '', // 本行代付成本
        repayCostOtherBank: '', // 跨行代付成
        // 2.代扣业务
        // 代扣能力
        deductStart: true, // 代扣业务是否启用
        channelRecordList: [
          // {
          //   cardId: '', //输入一个银行名称，会返回一个类
          //   repayRate: '', // 代扣成本(费率)
          //   repayLowest: '', // 代扣成本(保底)
          // }
        ],

        // 结算信息
        financeUserName: '', //财务对接人
        financeUserPhone: '', // 财务对接人 联系电话
        techUserName: '', //技术对接人
        techUserPhone: '', //技术对接人 联系电话
        settleName: '', //结算账户
        settleCardNo: '', // 账号
        settleOpenBank: '', // 开户行

        status: '' // 状态: 启用 停用
      },
      repayCostBankList: '', // 代付关联渠道
      deductCostBankList: '', // 代扣关联渠道
      // 代扣能力
      tableData: [
        {
          cardId: '',
          bankName: '',
          sign: '',
          repayRate: '',
          repayLowest: ''
        }
      ],
      // 成本录入列表
      payChannelPaymentsList: [
        {
          type: 1,
          paymentType: 1,
          typeCode: '',
          rate: '',
          // billingMode: '',
          status: ''
        },
        {
          type: 2,
          paymentType: 2,
          typeCode: '',
          rate: '',
          // billingMode: '',
          status: ''
        },
        {
          type: 3,
          paymentType: 3,
          typeCode: '',
          rate: '',
          // billingMode: '',
          status: ''
        },
        {
          type: 4,
          paymentType: 4,
          typeCode: '',
          rate: '',
          // billingMode: '',
          status: ''
        },
        {
          type: 5,
          paymentType: 5,
          typeCode: '',
          rate: '',
          // billingMode: '',
          status: ''
        }
      ]
    }
  },

  filters: {
    // 成本录入
    filCostEntry(value) {
      return {
        1: '微信支付标识(WX)',
        2: '支付宝支付标识(ZFB)',
        3: '银联云支付标识(YLY)',
        4: '京东支付标识(JD)',
        5: 'POS支付标识(POS)'
      }[value]
    }
  },

  created() {
    this.getChannelDetails()
  },

  methods: {
    // 设置坐标
    setIndex(index) {
      this.index = index
    },

    async querySearch(queryString, cb) {
      await this.searchData(queryString)
      console.log('querySearch', 1, ':', queryString, this.restaurants)
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },

    createFilter(queryString) {
      console.log(2)
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0
        )
      }
    },

    handleSelect(item) {
      this.tableData[this.index].sign = item.sign
      this.tableData[this.index].cardId = item.cardId

      console.log('点击确认选择4:', item, '代扣成本表格:', this.tableData)
    },

    // 保理渠道 - 新增 - 渠道名称查询出代扣能力信息
    async searchData(scope) {
      let {
        $store: { dispatch }
      } = this

      let dispatchEvent = 'T4/paymentChannel/bankNameFindRepayPower'

      if (scope.length >= 2) {
        let res = await dispatch(dispatchEvent, {
          bankName: scope
        })
        let temp = []
        res.data.map(item => {
          temp.push({
            value: item.bankName,
            cardId: item.cardId,
            sign: item.sign
          })
        })
        this.restaurants = temp
        console.log('发送请求1:', temp)
        // console.log(this.restaurants)
      }
    },

    // 代扣业务
    add() {
      this.tableData.push({
        cardId: '',
        bankName: '',
        sign: '',
        repayRate: '',
        repayLowest: ''
      })
    },

    del(index) {
      console.log(this.tableData.splice(index, 1))
      // this.tableData = this.tableData.splice(1, 1)

      // console.log(row, 'del')
    },

    // 通道详情
    async getChannelDetails() {
      const {
        id,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T4/paymentChannel/getChannelDetails'

      this.showLoading = true
      let data = await dispatch(dispatchEvent, { id })
      // console.log(data, '支付通道详情')

      Object.keys(this.postData).forEach(key => {
        this.postData[key] = data.payChannel[key]
      })

      // 测试成本录入启用
      // this.postData.incomeStart = true
      // this.postData.repayStart = true
      // this.postData.deductStart = true

      // 成本录入
      if (data.payChannelPayment instanceof Array) {
        this.payChannelPaymentsList.map(item => {
          data.payChannelPayment.map(item1 => {
            if (item.paymentType == item1.paymentType) {
              Object.keys(item).forEach(key => {
                item[key] = item1[key]
              })
            }
          })
        })
      }

      // 1.代付关联渠道
      if (data.deductList) {
        let temp = []
        data.deductList.map(item => {
          temp.push(item.bankName)
        })
        this.repayCostBankList = temp.toString()
      }

      // 2.代扣关联渠道
      if (data.repayList) {
        let temp = []
        data.repayList.map(item => {
          temp.push(item.bankName)
        })

        this.deductCostBankList = temp.toString()
      }
      // 代扣能力
      data.channelRecord ? (this.tableData = data.channelRecord) : ''

      // 收单业务信息启用
      data.payChannel.incomeStart == 1
        ? (this.postData.incomeStart = true)
        : (this.postData.incomeStart = false)

      // // 贷记业务信息 代付
      data.payChannel.repayStart == 1
        ? (this.postData.repayStart = true)
        : (this.postData.repayStart = false)
      // // 贷记业务信息 代扣
      data.payChannel.deductStart == 1
        ? (this.postData.deductStart = true)
        : (this.postData.deductStart = false)

      this.showLoading = false
    },

    // 修改
    async confirmEditor() {
      const {
        postData,
        $store: { dispatch }
      } = this
      const dispatchEvent = 'T4/paymentChannel/confirmEditor'

      postData.channelRecordList = this.tableData
      postData.payChannelPaymentsList = this.payChannelPaymentsList

      let { status } = await dispatch(dispatchEvent, postData)

      if (status == 200) {
        this.$alert('通道修改成功').then(() => {
          this.$router.back()
        })
      }

      // console.log(JSON.parse(JSON.stringify(postData)), '点击确认修改')

      // 必填字段
      // const requiredFiled = {
      //   code: '支付代码',
      //   communicationSt: '通讯方式',
      //   conversionMerchant: '转换商户号',
      //   cutTime: '日切时间',
      //   endTime: '交易结束时间',
      //   financeUserName: '财务对接人姓名',
      //   financeUserPhone: '财务对接人电话',
      //   incomeSt: '收款形式',
      //   maxAmt: '最大交易金额',
      //   messageHeader: '报文头',
      //   minAmt: '最小交易金额',
      //   passagewayAbbreviation: '通道简称',
      //   passagewayName: '通道名称',
      //   productName: '产品名称',
      //   settleSt: '结算方式',
      //   // settlement: '分润结算',
      //   startTime: '交易开始时间',
      //   techUserName: '技术对接人姓名',
      //   techUserPhone: '技术对接人电话'
      // }

      // for (let key in postData) {
      //   if (requiredFiled[key] && !postData[key]) {
      //     this.$alert.error(requiredFiled[key] + '不能为空!')
      //     return false
      //   }
      // }

      // const PHONE_REGEXP = /^1[3456789]\d{9}/
      // if (!PHONE_REGEXP.test(postData.financeUserPhone)) {
      //   this.$alert.error('财务对接人电话格式不正确!')
      //   return false
      // } else if (!PHONE_REGEXP.test(postData.techUserPhone)) {
      //   this.$alert.error('技术对接人电话格式不正确!')
      //   return false
      // }

      // this.payChannelPaymentsList.forEach((item, index) => {
      //   if (!item.typeCode.trim().length) {
      //     // item.paymentType = ''
      //     item.rate = ''
      //     item.billingMode = ''
      //     item.status = ''
      //   } else {
      //     item.paymentType = index + 1
      //   }
      // })

      // this.showLoading = true
      // this.postData.payChannelPaymentsList = this.payChannelPaymentsList
      // dispatch(dispatchEvent, this.postData).then(({ status }) => {
      //   this.showLoading = false

      //   if (status === 200) {
      //     this.$alert('通道修改成功').then(() => {
      //       this.$router.back()
      //     })
      //   }
      // })
    },

    onInputAbbreviation(value) {
      this.postData.passagewayAbbreviation = value
        .replace(/\W/g, '')
        .toUpperCase()
    },

    onInputTypeCode(index, value) {
      this.payChannelPaymentsList[index].typeCode = value
        .replace(/\W/g, '')
        .toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/detailsTable.scss';

.payment-channel-subpage {
  .el-radio-group {
    padding-left: 8px;

    /deep/ .el-radio__label {
      padding-left: 5px;
    }
  }

  /deep/ .el-input {
    height: 100%;
  }

  /deep/ .el-input__inner {
    margin-top: -1px;
  }
}
.center /deep/ .el-input__inner {
  text-align: center;
}

/deep/ .el-table .cell {
  text-align: center;
}

/deep/ .colorfule-date-picker .el-input .el-input__inner {
  text-align: center;
}

.span-center {
  top: 30%;
}
#app .el-table {
  height: auto !important;
}
</style>
